import { render, staticRenderFns } from "./SettlementForm1.vue?vue&type=template&id=54175766&scoped=true&"
import script from "./SettlementForm1.vue?vue&type=script&lang=js&"
export * from "./SettlementForm1.vue?vue&type=script&lang=js&"
import style0 from "./SettlementForm1.vue?vue&type=style&index=0&id=54175766&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54175766",
  null
  
)

export default component.exports